import {
  Children,
  PropsWithChildren,
  SVGProps,
  cloneElement,
  isValidElement,
} from "react";

import { Box, TypographyProps } from "@aircall/tractor";

import { InputChoiceContextValue } from "../../contexts/InputChoiceContext";
import { useInputChoice } from "../../contexts/useInputChoice";

import { InputChoiceIconProps } from ".";

function pickColor({
  isSelected,
  isDisabled,
}: InputChoiceContextValue): TypographyProps["color"] {
  if (isDisabled) {
    return "icon-disabled";
  }

  if (isSelected) {
    return "icon-inverted";
  }

  return "icon-base";
}

export function InputChoiceIcon({
  children,
  "data-test": dataTest = "input-choice-icon",
  ...props
}: PropsWithChildren<InputChoiceIconProps>) {
  const { isSelected, isDisabled } = useInputChoice();

  const pickedColor = pickColor({
    isSelected,
    isDisabled,
  });

  const childrenWithColor = Children.map(children, (child) => {
    if (!isValidElement(child)) {
      return null;
    }

    // Not sure how to avoid asserting, and pass the right type to cloneElement.
    return cloneElement<SVGProps<SVGSVGElement>>(child as any, {
      color: pickedColor as string,
    });
  });

  return (
    <Box data-test={dataTest} {...props}>
      {childrenWithColor}
    </Box>
  );
}
